module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.spec) ? _c('div', {
    staticClass: "spec-view",
    class: _vm.specView_cls
  }, [_c('box', [_c('div', {
    staticClass: "specsheet"
  }, [_c('div', {
    staticClass: "heypart"
  }, [(0) ? _c('p', [_c('b', [_vm._v("Hey — ")]), _vm._v("\n\t\t\t\t\tVi ved godt at vores opgavespecifikationer kan være til den tørre side. \n\t\t\t\t\tDog er de ret vigtige at du alligevel bruger et øjeblik på at nærlæse, da det er vigtigt at vi er helt \n\t\t\t\t\tenige om det arbejde der skal laves og dine forventninger og krav dertil. \n\t\t\t\t\tPå den måde får vi en super tilfreds kunde, hvilket er det vigtigste for os. \n\t\t\t\t\tDet er derfor super vigtigt at dine forventninger til arbejdet og den løsning vi udfører er definerede \n\t\t\t\t\ti vores specifikation nedenfor, så der ikke senere opstår tvivl.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (0) ? _c('p', [_vm._v("\n\t\t\t\t\tI Milk går vi meget op i at du som kunde er 100% tilfreds med din løsning.\n\t\t\t\t\tDerfor nørder vi altid opgavespecifikation — selvom det ikke er den sjoveste del."), _c('br'), _vm._v("\n\t\t\t\t\tVi beder dig her hjælpe med at sikre at dine ønsker og forventninger til opgaven, samt eventuelle detaljer, er klart beskrevet i punkterne nedenfor.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (1) ? _c('p', [_vm._v("\n\t\t\t\t\tVi går meget op i at du som kunde bliver 100% tilfreds med din løsning, og derfor nørder vi altid opgavespecifikationen.\n\t\t\t\t\tVi beder dig hjælpe med at sikre at dine ønsker er klart beskrevet, så forventninger og detaljer bliver afstemt inden projektopstart.\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pretitle",
    domProps: {
      "innerHTML": _vm._s(_vm.pretitle)
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.legaltext1)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.legaltext2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.legaltext2)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "taskcats"
  }, _vm._l((_vm.spec.taskcats), function(taskcat, taskcat_i) {
    return _c('div', {
      key: 'asdf' + taskcat_i,
      staticClass: "taskcat"
    }, [_c('div', {
      staticClass: "row row-taskcat"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (taskcat.title),
        expression: "taskcat.title"
      }],
      staticClass: "input-taskcat-title",
      attrs: {
        "type": "text",
        "placeholder": "Kategori"
      },
      domProps: {
        "value": (taskcat.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(taskcat, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "hrs-title"
    }, [_vm._v("Arbejdstimer")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(false) ? _c('div', {
      staticClass: "dragger"
    }, [_vm._v("=")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "taskcat-up-down"
    }, [(taskcat_i > 0) ? _c('div', {
      staticClass: "up",
      on: {
        "click": function($event) {
          return _vm.taskCatMoveUp(taskcat, taskcat_i)
        }
      }
    }) : _vm._e(), _vm._v(" "), (taskcat_i < (_vm.spec.taskcats.length - 1)) ? _c('div', {
      staticClass: "down",
      on: {
        "click": function($event) {
          return _vm.taskCatMoveDown(taskcat, taskcat_i)
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.spec.taskcats.length > 1) ? _c('div', {
      staticClass: "taskcat-delete-btn",
      on: {
        "click": function($event) {
          return _vm.taskcatDelete(taskcat, taskcat_i)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "ionicons/ios-trash-outline"
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "tasks"
    }, [_c('draggable', {
      attrs: {
        "options": {
          group: 'tasks',
          handle: '.dragger'
        }
      },
      on: {
        "start": _vm.task_drag_start,
        "end": _vm.task_drag_end,
        "add": _vm.task_drag_add,
        "remove": _vm.task_drag_remove
      },
      model: {
        value: (taskcat.tasks),
        callback: function($$v) {
          _vm.$set(taskcat, "tasks", $$v)
        },
        expression: "taskcat.tasks"
      }
    }, _vm._l((taskcat.tasks), function(task, task_i) {
      return _c('div', {
        key: 'task' + task_i,
        staticClass: "task",
        class: _vm.taskClasses(task)
      }, [_c('div', {
        staticClass: "row row-task"
      }, [_c('div', {
        staticClass: "col"
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (task.title),
          expression: "task.title"
        }],
        ref: 'taskTitle' + taskcat_i + '-' + task_i,
        refInFor: true,
        staticClass: "input-task-title",
        attrs: {
          "rows": "1",
          "data-min-rows": "1",
          "placeholder": "Opgavelinje"
        },
        domProps: {
          "value": (task.title)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "title", $event.target.value)
          }, function($event) {
            return _vm.autoSizeTextArea(taskcat_i, task_i)
          }]
        }
      }), _vm._v(" "), (_vm.spec.showDescriptions) ? _c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (task.text),
          expression: "task.text"
        }],
        ref: 'taskText' + taskcat_i + '-' + task_i,
        refInFor: true,
        staticClass: "input-task-text",
        attrs: {
          "rows": "1",
          "data-min-rows": "1",
          "placeholder": "?"
        },
        domProps: {
          "value": (task.text)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "text", $event.target.value)
          }, function($event) {
            return _vm.autoSizeTextArea2(taskcat_i, task_i)
          }]
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "task-optional",
        on: {
          "click": function($event) {
            return _vm.toggleTaskOptional(task)
          }
        }
      }, [(1 + 1 == 2) ? [(task.optional === undefined) ? [_vm._v("—")] : _vm._e(), _vm._v(" "), (task.optional === false) ? [_vm._v("Tilvalg")] : _vm._e(), _vm._v(" "), (task.optional === true) ? [_vm._v("Tilvalg")] : _vm._e()] : _vm._e(), _vm._v(" "), (1 + 1 == 3) ? [(task.optional === undefined) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-minus-empty"
        }
      }) : _vm._e(), _vm._v(" "), (task.optional === false) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/android-close"
        }
      }) : _vm._e(), _vm._v(" "), (task.optional === true) ? _c('svgicon', {
        attrs: {
          "icon": "ionicons/checkmark"
        }
      }) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (task.hours),
          expression: "task.hours",
          modifiers: {
            "number": true
          }
        }],
        staticClass: "input-hours",
        attrs: {
          "type": "number",
          "tabindex": 666 + (taskcat_i * 100) + task_i
        },
        domProps: {
          "value": (task.hours)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(task, "hours", _vm._n($event.target.value))
          },
          "blur": function($event) {
            return _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [(_vm.spec.showLineTotals) ? _c('div', {
        staticClass: "task-budget"
      }, [_vm._v("\n   \t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.outputMoney((task.hours * _vm.hour_rate))) + "\t\t\t\t\t\t\t\t\t\t\n   \t\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "dragger"
      }, [_vm._v("=")])]), _vm._v(" "), _c('div', {
        staticClass: "col"
      }, [_c('div', {
        staticClass: "task-delete-btn",
        on: {
          "click": function($event) {
            return _vm.taskDelete(task, task_i, taskcat, taskcat_i)
          }
        }
      }, [_c('svgicon', {
        attrs: {
          "icon": "ionicons/ios-trash-outline"
        }
      })], 1)])])])
    }), 0)], 1), _vm._v(" "), _c('div', {
      staticClass: "subtotal"
    }, [_c('div', {
      staticClass: "row row-subtotal"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.addTask(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tIndsæt række\n\t\t\t\t\t\t\t\t")]), _vm._v("   \n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.addTaskcat(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tkategori\n\t\t\t\t\t\t\t\t")]), _vm._v("   \n\t\t\t\t\t\t\t\t"), _c('span', {
      staticClass: "add-task-entry",
      on: {
        "click": function($event) {
          return _vm.triggerSpecLineRobot(taskcat_i)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\tforslag\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), (_vm.spec.showCatHrs) ? _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "subtotal-hours"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getCatTotalHours(taskcat)) + "\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col"
    }, [(_vm.spec.showCatTotals) ? _c('div', {
      staticClass: "subtotal-budget"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.outputMoney(_vm.getCatTotalBudget(taskcat))) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col"
    }), _vm._v(" "), _c('div', {
      staticClass: "col"
    })])])])
  }), 0), _vm._v(" "), (!_vm.spec.taskcats || !_vm.spec.taskcats.length) ? _c('div', {
    staticClass: "textlink",
    on: {
      "click": function($event) {
        return _vm.addTaskcat()
      }
    }
  }, [_vm._v("\n\t\t\t\tTIlføj kategori\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.spec.taskcats && _vm.spec.taskcats.length) ? _c('div', {
    staticClass: "total"
  }, [_c('div', {
    staticClass: "row row-total"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tTotal ex. moms\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-hours"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.total_hours) + "\t\t\t\t\t\t\t\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "total-budget"
  }, [_vm._v("\t\t\t\t\t\t\t\n\t\t\t\t\t\t\tkr. " + _vm._s(_vm._f("money")(_vm.total, 2)) + "\n\t\t\t\t\t\t")])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "btn add-task",
    on: {
      "click": function($event) {
        return _vm.addTask()
      }
    }
  }, [_vm._v("Tilføj række")]) : _vm._e(), _vm._v(" "), (_vm.legaltext_below) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s('<br><br>' + _vm.legaltext_below)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notes-section"
  }, [_c('h4', {}, [_vm._v("Betingelser")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.notes_text)
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.notes),
      expression: "spec.notes"
    }],
    ref: "notesTextArea",
    staticClass: "notes-text-input",
    class: {
      empty: (!_vm.spec.notes.length)
    },
    attrs: {
      "rows": "3",
      "data-min-rows": "1",
      "placeholder": "Særlige betingelser?"
    },
    domProps: {
      "value": (_vm.spec.notes)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.spec, "notes", $event.target.value)
      }, function($event) {
        return _vm.autoSizeTextAreaNotes()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spec-footer"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('svgicon', {
    attrs: {
      "icon": "logo"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Milk Studio ApS, Strandgade 70, 1. 1401 København K. CVR 38750224")])])])]), _vm._v(" "), _c('box', {
    attrs: {
      "label": "Visning",
      "open": false,
      "header-toggle": "",
      "cls": "print-invisible"
    }
  }, [_c('div', {
    staticClass: "cols cols-4"
  }, [_c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleShowDescriptions()
      }
    }
  }, [(this.spec.showDescriptions) ? [_vm._v("● Tekstbeskrivelser")] : [_vm._v("○ Tekstbeskrivelser")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showLineTotals')
      }
    }
  }, [(_vm.spec.showLineTotals) ? [_vm._v("● Linje-totaler")] : [_vm._v("○ Linje-totaler")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showCatHrs')
      }
    }
  }, [(_vm.spec.showCatHrs) ? [_vm._v("● Kategori-timer")] : [_vm._v("○ Kategori-timer")]], 2), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "secondary",
      "full": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleSpecSetting('showCatTotals')
      }
    }
  }, [(_vm.spec.showCatTotals) ? [_vm._v("● Kategori-totaler")] : [_vm._v("○ Kategori-totaler")]], 2)], 1)]), _vm._v(" "), _c('box', {
    attrs: {
      "cls": "print-invisible"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col m25"
  }, [_c('inputfield', {
    attrs: {
      "label": "Dato"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.spec.date),
      expression: "spec.date"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.spec.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.spec, "date", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cloneSpec()
      }
    }
  }, [_vm._v("Kopiér fra...")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downloadPDF()
      }
    }
  }, [_vm._v("Download PDF")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col m25"
  }, [_c('btn', {
    attrs: {
      "full": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Gem")])], 1)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3587319c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Specsheet.vue
// module id = 595
// module chunks = 1